import { cva } from 'components/lib'

const Variants = cva(

  `group pointer-events-auto relative flex w-full items-center 
    justify-between space-x-4 overflow-hidden rounded-xl 
    backdrop-blur-xl backdrop-saturate-150 
    border border-white/10 p-6 pr-4 
    shadow-[0_8px_32px_rgba(0,0,0,0.12)] 
    transition-all duration-300 ease-out
    data-[swipe=cancel]:translate-x-0 
    data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] 
    data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] 
    data-[swipe=move]:transition-none 
    data-[state=open]:animate-in 
    data-[state=closed]:animate-out 
    data-[swipe=end]:animate-out 
    data-[state=closed]:fade-out-80 
    data-[state=closed]:slide-out-to-right-full 
    data-[state=open]:slide-in-from-top-full 
    data-[state=open]:sm:slide-in-from-bottom-full 
    mb-3 hover:shadow-[0_12px_40px_rgba(0,0,0,0.15)]
    hover:border-white/15 hover:-translate-y-0.5`,

  {
    variants: {
      variant: {
        default: 
          'bg-white/10 dark:bg-white/5 text-white backdrop-blur-xl backdrop-saturate-150',
        success: 
          'success group bg-emerald-500/20 dark:bg-emerald-400/15 text-white border-emerald-400/30 shadow-[0_8px_32px_rgba(16,185,129,0.15)]',
        info: 
          'info group bg-blue-500/20 dark:bg-blue-400/15 text-white border-blue-400/30 shadow-[0_8px_32px_rgba(59,130,246,0.15)]',
        error:
          'error group bg-red-500/20 dark:bg-red-400/15 text-white border-red-400/30 shadow-[0_8px_32px_rgba(239,68,68,0.15)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export { Variants };
